module.exports = __webpack_public_path__ + "4e64ada0ec74509790dcd8aa4db37324.png";